import React, { useState, useEffect } from "react";
import { Link } from 'react-router-dom';
import useStateRef from "react-usestateref";
import { useDispatch, useSelector } from "react-redux";
import { DEFAULT_IMAGE_140, DEFAULT_IMAGE_60 } from '../../middleware/types'


const ProductTile = (props) => {
	const [productDetailsView, setProductDetailsView, productDetailsViewRef] = useStateRef('')
	const [screenWidth, setScreenWidth, screenWidthRef] = useStateRef('')
	const profileDetails = useSelector(state => state.getProfileDetails.profileDetails)

	const handleQuickViewProductPage = (productId, productCount, event) => {
		event.preventDefault()
		props.productCountCallBack("")
		props.productDetailsCallBack("")
		props.setViewProductFamilyUrl(props.value.productUrl);
		fetch(`${window.location.protocol}//${window.location.hostname}/api/rest/cb/product/product-quick-view/${productId}`, {
			method: 'GET'
		}).then(res => res.json())
			.then(res => {
				if (res !== null) {
					//setIsLoading(false)
					setProductDetailsView(res)
					var productDetatils = (JSON.parse(res.response)).response
					props.productDetailsCallBack(productDetatils)
					props.productCountCallBack(productCount ? productCount : "")
					var modalElement = document.getElementById(`${productId ? productId : "quickViewModal"}`);
					var bootstrapModal = new bootstrap.Modal(modalElement);
					bootstrapModal.show();
					let quickViewData = {
						"event": "quick_view",
						"page_name": "no-cache",
						"product_id": productId
					}
					window.dataLayer = window.dataLayer || []
					if (window.dataLayer.length > 0) {
						window.dataLayer.push(quickViewData)
					}
					//document.getElementById("hiddenSharePageModal").click()
				} else {
					//setIsLoading(false)
					//const error = res._ERROR_MESSAGE_;
					//setErrorMessage(error);
					//document.getElementById("login-message-error-div").classList.remove("d-none");
					// console.log("errorMessage ---->>>>!!!!", errorMessage)
				}
			})
	}

	function replaceGridViewImage(event) {
		event.target.src = DEFAULT_IMAGE_140;
	}

	function replaceListViewImage(event) {
		event.target.src = DEFAULT_IMAGE_60;
	}

	useEffect(() => {
		setScreenWidth(screen.width)
	}, [])


	return (
		<>
			{props.currentPageView === "gridView" ?
				<div className={`product-grid-view ${props.gridViewCol ? props.gridViewCol : "col-6 col-md-3 col-lg-3"}`}>
					<div class="c-feature-product qv-model" >
						<Link to={props.value["productUrl"]} class="c-product-link">
							{screenWidthRef.current > 810 ?
								<img alt={props.value["product.productName"] ? props.value["product.productName"] : ""} onError={replaceGridViewImage} src={props.domainName.concat(props.value["product.smallImageUrl"]) ? props.domainName.concat(props.value["product.smallImageUrl"]) : ""} class="c-product-img" fetchpriority={props.indexValue < props.documentFetchPriorityHighCount ? "high" : "low"} loading={props.indexValue < props.documentFetchPriorityHighCount ? "" : "lazy"} decoding="async"/>
								:
								<img alt={props.value["product.productName"] ? props.value["product.productName"] : ""} onError={replaceGridViewImage} src={props.domainName.concat(props.value["product.smallImageUrl"]) ? props.domainName.concat(props.value["product.smallImageUrl"]) : ""} class="c-product-img" decoding="async"/>}

							<h3 class="cb-product-title" dangerouslySetInnerHTML={{ __html: props.value["product.productName"] ? props.value["product.productName"] : "" }}>
							</h3>
						</Link>
						{props.pageType === "resources" ? "" :
							<div className="">
								{props.value["product.familyProduct.count"] ? <p class="c-product-total">{props.value["product.familyProduct.count"] ? props.value["product.familyProduct.count"] : ""}&nbsp; Products</p> : props.value["product.productId"] ? <p class="c-product-total">Item #{props.value["product.productId"] ? props.value["product.productId"] : ""}</p> : ""}
								{profileDetails && profileDetails.hidePrice === "true" && profileDetails.call_for_pricing ? <p class="c-product-price">{profileDetails.call_for_pricing}</p> :
									profileDetails && profileDetails.userType == "2" ?
										<>
											{props.value.retailPrice != null && props.value.retailPrice != undefined ?
												props.value.contractPrice ?
													<span class="contract-price-value-b2i">{props.value.contractPrice ? props.value.contractPrice : ""}</span> :
													<div class="prod-contract-disc">
														<div class="prod-contract-price">
															<span class="contract-price-value">{props.value.itemPrice ? props.value.itemPrice : ""}</span>
														</div>
													</div>
												: props.value.contractPrice && props.value.itemPrice ? <div className="d-flex cb-list-price-red"> <p class="list-price-value mx-1">{props.value.itemPrice ? props.value.itemPrice : ""}</p> <span class="c-product-price-value">{props.value.contractPrice ? props.value.contractPrice : ""}</span></div> :
													<div class="prod-contract-disc">
														<div class="prod-contract-price">
															<span class="contract-price-value">{props.value.itemPrice ? props.value.itemPrice : ""}</span>
														</div>
													</div>}

											{props.value.retailPrice && props.value.retailPrice != "$0.00" ? <div class="prod-retail-price">
												Retail&nbsp;<span class="list-price-value">{props.value.retailPrice}</span>
											</div> : ""} </> : <>
											{props.value.oldPrice ? <div className="d-flex cb-list-price-red"> <p class="list-price-value mx-1">{props.value.oldPrice ? props.value.oldPrice : ""}</p> <span class="c-product-price-value">{props.value.itemPrice ? props.value.itemPrice : ""}</span></div> :
												<p class="c-product-price">{props.value.qtyRange ? props.value.qtyRange : props.value.itemPrice ? props.value.itemPrice : ""}</p>}
										</>}

								{profileDetails && profileDetails.call_for_pricing ? "" : <div className="">
									{props.value && props.value.qtyDiscountAvailable && props.value.qtyDiscountAvailable == true ? <p className="my-0 cb-itemDiscount">Qty Discount Available</p> : ""}
								</div>}
								<div class="c-product-rating">
									{props.value.reviewURLAverage ?
										screenWidthRef.current > 810 ?
											<img src={`/images/stars/50/rating-${props.value.reviewURLAverage ? props.value.reviewURLAverage : ""}_50.png`} alt={props.value.reviewURLAverage ? props.value.reviewURLAverage : ""} fetchpriority={props.indexValue <= props.documentFetchPriorityHighCount ? "high" : "low"} loading={props.indexValue < props.documentFetchPriorityHighCount ? "" : "lazy"} decoding="async"/>
											:
											<img src={`/images/stars/50/rating-${props.value.reviewURLAverage ? props.value.reviewURLAverage : ""}_50.png`} alt={props.value.reviewURLAverage ? props.value.reviewURLAverage : ""} decoding="async"/>
										: ""}
								</div>
							</div>}
						{props.pageType === "resources" ? "" : <>
							<button type="click" className="btn quick-btn modal-link" onClick={((event) => handleQuickViewProductPage(props.value["product.itemGroupId"] ? props.value["product.itemGroupId"] :props.value["product.productId"], props.value["product.familyProduct.count"], event))}>Quick View</button>
						</>}
					</div>
				</div>

				: <>
					{props.pageType === "resources" ?
						<div className={`col-12 resource-list-view ${props.pageType && props.pageType === "resources" ? "d-block" : ""}`}>
							<div className="c-resource-content">
								<div className="c-resource-image">
									<Link to={props.value.productUrl}>
										{screenWidthRef.current > 810 ?
											<img alt={props.value["product.productName"] ? props.value["product.productName"] : ""} onError={replaceListViewImage} src={props.domainName.concat(props.value["product.thumbnailImg"]) ? props.domainName.concat(props.value["product.thumbnailImg"]) : ""} fetchpriority={props.indexValue < props.documentFetchPriorityHighCount ? "high" : "low"} loading={props.indexValue < props.documentFetchPriorityHighCount ? "" : "lazy"} decoding="async"/>
											:
											<img alt={props.value["product.productName"] ? props.value["product.productName"] : ""} onError={replaceListViewImage} src={props.domainName.concat(props.value["product.thumbnailImg"]) ? props.domainName.concat(props.value["product.thumbnailImg"]) : ""} decoding="async"/>}

									</Link>
								</div>
								<div class="c-resource-head">
									<Link className="c-resource-title" to={props.value.productUrl ? props.value.productUrl : ""} dangerouslySetInnerHTML={{ __html: props.value["product.productName"] ? props.value["product.productName"] : "" }} />
									<h3 className="c-resource-info" dangerouslySetInnerHTML={{ __html: props.value["product.shortDescription"] ? props.value["product.shortDescription"] : "" }}></h3><Link className="c-resource-viewmore" to={props.value.productUrl ? props.value.productUrl : ""}> View »</Link>
								</div>
							</div>
						</div> :
						<div className="col-12 col-md-12 product-list-view">
							<div className="c-feature-list-product qv-model">
								<Link to={props.value["productUrl"]} className="c-product-link">
									{screenWidthRef.current > 810 ?
										<img alt={props.value["product.productName"] ? props.value["product.productName"] : ""} onError={replaceListViewImage} className="c-product-img" onerror="this.src='/images/fpo/product-60x60.gif'" src={props.domainName.concat(props.value["product.thumbnailImg"]) ? props.domainName.concat(props.value["product.thumbnailImg"]) : ""} fetchpriority={props.indexValue < props.documentFetchPriorityHighCount ? "high" : "low"} loading={props.indexValue < props.documentFetchPriorityHighCount ? "" : "lazy"} decoding="async"/>
										:
										<img alt={props.value["product.productName"] ? props.value["product.productName"] : ""} onError={replaceListViewImage} className="c-product-img" onerror="this.src='/images/fpo/product-60x60.gif'" src={props.domainName.concat(props.value["product.thumbnailImg"]) ? props.domainName.concat(props.value["product.thumbnailImg"]) : ""} decoding="async"/>}
									<h3 class="cb-product-title" dangerouslySetInnerHTML={{ __html: props.value["product.productName"] ? props.value["product.productName"] : "" }}></h3>
								</Link>
								{props.value["product.familyProduct.count"] ? <p class="c-product-total">{props.value["product.familyProduct.count"] ? props.value["product.familyProduct.count"] : ""}&nbsp; Products</p> : props.value["product.productId"] ? <p class="c-product-total">Item #{props.value["product.productId"] ? props.value["product.productId"] : ""}</p> : ""}
								<ul className="c-feature-items-icons">
									{props.value.hazmatWarningIconUrls ? props.value.hazmatWarningIconUrls.map((item) => {
										return (<li>
											{screenWidthRef.current > 810 ?
												<img alt="hazmat-warning" src={`${item}`} fetchpriority={props.indexValue < props.documentFetchPriorityHighCount ? "high" : "low"} loading={props.indexValue < props.documentFetchPriorityHighCount ? "" : "lazy"} decoding="async"/>
												:
												<img alt="hazmat-warning" src={`${item}`} decoding="async"/>}

										</li>)
									}) : ""}
								</ul>

								<div className="c-feature-list-right-section">
									{profileDetails && profileDetails.hidePrice === "true" && profileDetails.call_for_pricing ? <p class="c-product-price">{profileDetails.call_for_pricing}</p> :
										profileDetails && profileDetails.userType == "2" ?
											<>
												{props.value.retailPrice != null && props.value.retailPrice != undefined ?
													props.value.contractPrice ?
														<span class="contract-price-value-b2i">{props.value.contractPrice ? props.value.contractPrice : ""}</span> :
														<div class="prod-contract-disc">
															<div class="prod-contract-price">
																<span class="contract-price-value">{props.value.itemPrice ? props.value.itemPrice : ""}</span>
															</div>
														</div>
													: props.value.contractPrice && props.value.itemPrice ? <div className="d-flex cb-list-price-red"> <p class="list-price-value mx-1">{props.value.itemPrice ? props.value.itemPrice : ""}</p> <span class="c-product-price-value">{props.value.contractPrice ? props.value.contractPrice : ""}</span></div> :
														<div class="prod-contract-disc">
															<div class="prod-contract-price">
																<span class="contract-price-value">{props.value.itemPrice ? props.value.itemPrice : ""}</span>
															</div>
														</div>}

												{props.value.retailPrice && props.value.retailPrice != "$0.00" ? <div class="prod-retail-price">
													Retail&nbsp;<span class="list-price-value">{props.value.retailPrice}</span>
												</div> : ""}
											</> :
											<>
												{props.value.oldPrice ? <div className="d-flex cb-list-price-red"> <p class="list-price-value mx-1">{props.value.oldPrice ? props.value.oldPrice : ""}</p> <span class="c-product-price-value">{props.value.itemPrice ? props.value.itemPrice : ""}</span></div> :
													<p class="c-product-price">{props.value.qtyRange ? props.value.qtyRange : props.value.itemPrice ? props.value.itemPrice : ""}</p>}
											</>}

									{profileDetails && profileDetails.call_for_pricing ? "" : <div className="">
										{props.value && props.value.qtyDiscountAvailable && props.value.qtyDiscountAvailable == true ? <p className="my-0 cb-itemDiscount">Qty Discount Available</p> : ""}
									</div>}

								</div>
								{props?.value?.reviewURLAverage?
								<div class="c-product-rating">
									{screenWidthRef.current > 810 ?
										<img src={`/images/stars/50/rating-${props.value.reviewURLAverage ? props.value.reviewURLAverage : ""}_50.png`} alt={props.value.reviewURLAverage ? props.value.reviewURLAverage : ""} fetchpriority={props.indexValue < props.documentFetchPriorityHighCount ? "high" : "low"} loading={props.indexValue < props.documentFetchPriorityHighCount ? "" : "lazy"} decoding="async"/>
										:
										<img src={`/images/stars/50/rating-${props.value.reviewURLAverage ? props.value.reviewURLAverage : ""}_50.png`} alt={props.value.reviewURLAverage ? props.value.reviewURLAverage : ""} decoding="async"/>}

								</div>:""}
								<button type="click" className="btn quick-btn modal-link" onClick={((event) => handleQuickViewProductPage(props.value["product.itemGroupId"] ? props.value["product.itemGroupId"] :props.value["product.productId"], props.value["product.familyProduct.count"], event))}>Quick View</button>
							</div>
						</div>
					}
				</>}
		</>
	)
}

export default ProductTile